export const NAME = 'roboAdvisory';

export const quickFilterStates = {
	DRAFT: 'DRAFT',
	DONE: 'DONE',
	DONE_WITH_POLICY: 'DONE_WITH_POLICY',
	IN_PROGRESS: 'IN_PROGRESS',
	DONE_UNSIGNED: 'DONE_UNSIGNED',
};

export const raAnalysisTypes = {
	ONBOARDING: 'ONBOARDING',
	SMART_INVEST: 'SMART_INVEST',
	SMART_LIFE: 'SMART_LIFE',
	SMART_LIFE_INV: 'SMART_LIFE_INV',
	SMART_PROPERTY: 'SMART_PROPERTY',
	SMART_RESPONS: 'SMART_RESPONS',
	SMART_TRAVEL: 'SMART_TRAVEL',
	SMART_AUTO: 'SMART_AUTO',
};

export const dialogs = {
	SELECT_AMOUNT_LIMIT_FOR_HANDOVER: 'SELECT_AMOUNT_LIMIT_FOR_HANDOVER',
};

export const quickFilterTypesSetup = [
	{
		label: 'roboAdvisory:inProcess',
		type: quickFilterStates.DRAFT,
	},
	{
		label: 'roboAdvisory:finished',
		type: quickFilterStates.DONE,
	},
	{
		label: 'roboAdvisory:finishedWithContract',
		type: quickFilterStates.DONE_WITH_POLICY,
	},
	{
		label: 'roboAdvisory:finishedWithoutSignature',
		type: quickFilterStates.DONE_UNSIGNED,
	},
];

export const formDataFieldsMap = {
	surname: 'Příjmení',
	firstName: 'Jméno',
	businessName: 'Název',
	personIn: 'Rodné číslo',
	businessIn: 'IČO',
	zipCode: 'PSČ',
	municipality: 'Obec',
	product: 'Produkt',
	types: 'Druh analýzy',
	states: 'Stav analýzy',
	createdDateFrom: 'Datum vytvoření od',
	createdDateTo: 'Datum vytvoření do',
	quickFilterDone: 'Dokončené',
	quickFilterDoneWithPolicy: 'Dokončené se smlouvou',
	quickFilterDraft: 'Rozpracované',
	quickFilterDoneUnsigned: 'Dokončené bez podpisu',
};
